export const NOTIFICATION_FETCH = 'NOTIFICATION_FETCH';
export const NOTIFICATION_COUNT_FETCH = 'NOTIFICATION_COUNT_FETCH';
export const NOTIFICATION_ADMIN_APPROVE = 'NOTIFICATION_ADMIN_APPROVE';
export const NOTIFICATION_ADMIN_DECLINE = 'NOTIFICATION_ADMIN_DECLINE';
export const NOTIFICATION_COMPANY_CLOSE = 'NOTIFICATION_COMPANY_CLOSE';
